export class NominatimResponse {
  constructor(
    public latitude: number,
    public longitude: number,
    public displayName: string,
    public osmId?: number,
    public osmType?: string,
  ) { }
}
